const colorContainer = (value) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor:
    value === 'SIM' ? '#baffc9' : value === 'NAO' ? '#ffb3ba' : '#ffffba',
});

const columnOverrides = [
  {
    field: 'ativo',
    renderCell: ({ value }) => (
      <div style={colorContainer(value)}>
        <span>{value}</span>
      </div>
    ),
  },
];

export default columnOverrides;
